import Vue from "vue";
import VueRouter from "vue-router";
import Login from "../views/Login.vue";
import Logout from "../views/Logout.vue";
import Home from "../views/Home.vue";
import Settings from "../views/Settings.vue";
import Devices from "../views/Devices.vue";
import Sites from "../views/Sites.vue";
import Feeders from "../views/Feeders.vue";
import Sensors from "../views/Sensors.vue";
import Cameras from "../views/Cameras.vue";
import Users from "../views/Users.vue";
import FeedPlan from "../views/FeedPlan.vue";
import LastImages from "../views/LastImages.vue";
import Playback from "../views/Playback.vue";
import LiveCam from "../views/LiveCam.vue";
import LiveAiCam from "../views/LiveAiCam.vue";
import LiveCamDrt from "../views/LiveCamDrt.vue";
import DeviceChart from "../views/DeviceChart.vue";
import ChartSetting from "../views/ChartSetting.vue";
import NotificationConfigs from "../views/NotificationConfigs.vue";

Vue.use(VueRouter);

const routes = [
    {
        path: "/login",
        name: "Login",
        meta: { isPublic: true },
        component: Login,
    },
    {
        path: "/logout",
        name: "Logout",
        meta: { isPublic: true },
        component: Logout,
    },
    {
        path: "/",
        name: "Home",
        component: Home,
    },
    {
        name: "Settings",
        path: "/settings",
        component: Settings,
    },
    {
        name: "ChartSetting",
        path: "/chart-setting",
        component: ChartSetting,
    },
    {
        path: "/devices",
        name: "Devices",
        component: Devices,
    },
    {
        path: "/sites",
        name: "Sites",
        component: Sites,
    },
    {
        path: "/feeders",
        name: "Feeders",
        component: Feeders,
    },
    {
        path: "/sensors",
        name: "Sensors",
        component: Sensors,
    },
    {
        path: "/cameras",
        name: "Cameras",
        component: Cameras,
    },
    {
        path: "/users",
        name: "Users",
        component: Users,
    },
    {
        path: "/feed-plan/:device_id",
        name: "FeedPlan",
        component: FeedPlan,
    },
    {
        path: "/last-images",
        name: "LastImages",
        component: LastImages,
    },
    {
        path: "/playback/:camera_id",
        name: "Playback",
        component: Playback,
    },
    {
        path: "/device-chart/:device_id",
        name: "DeviceChart",
        component: DeviceChart,
    },
    {
        path: "/live-cam/:device_id/:feeder_id/:camera_id",
        name: "LiveCam",
        component: LiveCam,
    },
    {
        path: "/live-cam-drt/:device_id/:feeder_id/:camera_id",
        name: "LiveCamDrt",
        component: LiveCamDrt,
    },
    {
        path: "/live-ai-cam/:device_id/:camera_id",
        name: "LiveAiCam",
        component: LiveAiCam,
    },
    {
        path: "/notification-configs",
        name: "NotificationConfigs",
        component: NotificationConfigs,
    },
    {
        path: "/about",
        name: "About",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ "../views/About.vue"),
    },
];

const router = new VueRouter({
    routes,
});

export default router;
